export default __webpack_public_path__ + "static/media/hero-img-mobile.e993cc6d.png";